module.exports = __webpack_public_path__ + "media/images/ceba-logo-white-text-c60595cd.png";